import { render, staticRenderFns } from "./TendersList.vue?vue&type=template&id=8d9bfe54&"
import script from "./TendersList.vue?vue&type=script&lang=js&"
export * from "./TendersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports